import { ActionTypes } from "../constants/action-types";

const initialState = {
    certificate: [],
};

export const FetchAllCertificate = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.FETCH_ALL_CERTIFICATE:
      return { ...state, certificate: payload };
    default:
      return state;
  }
};
